export const LOAD_DOCUMENTS_SENDERS_SUCCESS = 'LOAD_DOCUMENTS_SENDERS_SUCCESS';
export const LOAD_DOCUMENTS_SENDERS_FAILED = 'LOAD_DOCUMENTS_SENDERS_FAILED';
export const GET_DOCUMENT_DETAILS = 'GET_DOCUMENT_DETAILS';
export const SET_LOADING = 'SET_LOADING';
export const LOAD = 'LOAD';
export const LOAD_SUCCESS = 'LOAD_SUCCESS';
export const LOAD_FAILED = 'LOAD_FAILED';
export const LOAD_ERROR = 'LOAD_ERROR';
export const LOAD_ONE = 'LOAD_ONE';
export const GET_SUBSCRIBED_FILE_TYPES = 'GET_SUBSCRIBED_FILE_TYPES';
export const LOAD_FOLDERS_SUCCESS = 'LOAD_FOLDER_SUCCESS';
export const LOAD_FOLDERS_FAILED = 'LOAD_FOLDER_FAILED';
export const LOAD_STATS_SUCCESS = 'LOAD_STATS_SUCCESS';
export const LOAD_STATS_FAILED = 'LOAD_STATS_FAILED';



// WEBPACK FOOTER //
// ./src/store/modules/documents/types.js